<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { onMount } from 'svelte';
import { fade, fly } from 'svelte/transition';
import uiStore from '../../utils/UIStore';
import { renderMarkdown } from '../../utils/markdownParser';

let faqs = [];

//load ui texts from ui Store
uiStore.textStore.subscribe((store) => {
  if (store.texts != null) {
    const data = store.texts;
    faqs = data.faqs.map((item) =>
      Object.assign({
        name: item.name,
        subfaqs: item.subfaqs.map((subfaq) =>
          Object.assign({
            title: subfaq.title,
            answer: renderMarkdown(subfaq.answer.join('\n\n')),
          }),
        ),
      }),
    );
  }
});

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

//if there is an anchor in the url -> open details section on mounted
onMount(async () => {
  const anchor = window.location.hash.substring(1);
  if (anchor !== '' && anchor != null) {
    const elem = document.getElementById(anchor);
    if (elem != null) {
      document.getElementById(anchor).open = true;
    }
  }
});
</script>

<svelte:head>
  <title>{uiTexts.pageTitles.faq}</title>
</svelte:head>

<main transition:fade>
  <h1 in:fly={{ y: -20, duration: 500 }}>{uiTexts.faq.pageTitle}</h1>

  <div
    id="content1"
    class="text_box"
    in:fly={{ y: -20, duration: 500, delay: 200 }}
  >
    <ol>
      {#if faqs != []}
        {#each faqs as faq, idx}
          <details>
            <summary style="font-size: 1.4rem;">{idx + 1}. {faq.name}</summary>
            <div class="detail-content">
              <ol>
                {#each faq.subfaqs as subfaq, subidx}
                  <details>
                    <summary style="font-size: 1.1rem;"
                      >{idx + 1}.{subidx + 1}. {subfaq.title}</summary
                    >
                    <div class="detail-content">
                      {@html subfaq.answer}
                    </div>
                  </details>
                {/each}
              </ol>
            </div>
          </details>
        {/each}
      {/if}

      <details id="versionshinweise">
        <summary style="font-size: 1.4rem;">{faqs.length + 1}. {uiTexts.faq.releaseNotesTitle}</summary>
        <div class="detail-content">
          <p>{@html uiTexts.faq.releaseNotesDescription}</p>
        </div>
      </details>
    </ol>
  </div>
</main>

<style>

  h1{
    font-size: 2rem;
    margin-top: 25px;
    margin-bottom: 30px;
  }
  ol {
    display: grid;
    gap: 10px;
    margin-top: 10px;
  }

  main {
    text-align: left;
    padding-left: 20vw;
    padding-right: 20vw;
    padding-top: 90px;
    margin: 0 auto;
    width: 100%;
    padding-bottom: 120px;
    display: grid;
    background-size: 90%;
    background-repeat: no-repeat;
    background-position: center;
  }

  p,
  li {
    font-size: 1.1rem;
    text-decoration: none;
  }

  summary {
    font-weight: 700;
    font-size: 1.2rem;
    cursor: pointer;
  }

  .detail-content {
    padding-left: 25px;
  }


  @media screen and (max-width: 950px) {
    p,
    li{
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 500px) {
    .text_box {
      width: 95vw;
      text-align: left !important;
    }
  }
</style>
